import Column from '../Model/Specification/Column';

export function isColumnPlural(column: Column)
{
    return column.fieldPath.path.isPlural;
}
